import { createAction } from "redux-actions";
import { ANALYTICS_LOAD_MORE, ANALYTICS_LOAD_PREVIOUS } from "../constants";
import { mapAnalyticsProducts } from "../../../../analytics/mapAnalyticsProducts";

const payloadCreator = ({ response: { products = [] }, page }) => ({
  returnedProductList: mapAnalyticsProducts({ products }),
  page
});

const unaryCreateAction = type => createAction(type, payloadCreator);

const [analyticsLoadMore, analyticsLoadPrevious] = [
  ANALYTICS_LOAD_MORE,
  ANALYTICS_LOAD_PREVIOUS
].map(unaryCreateAction);

export { analyticsLoadMore, analyticsLoadPrevious };
